import { createActionConst } from '../../../../utils/action.utils';

const USERS_NAMESPACE = 'USERS';

export const FETCH_USERS = createActionConst(USERS_NAMESPACE, 'FETCH_USERS');
export const CREATE_USER = createActionConst(USERS_NAMESPACE, 'CREATE_USER');
export const UPDATE_USER = createActionConst(USERS_NAMESPACE, 'UPDATE_USER');
export const CHANGE_PASSWORD = createActionConst(USERS_NAMESPACE, 'CHANGE_PASSWORD');
export const CHECK_USER_EXISTENCE = createActionConst(USERS_NAMESPACE, 'CHECK_USER_EXISTENCE');

export const DELETE_USER = createActionConst(USERS_NAMESPACE, 'DELETE_USER');
export const ENABLE_USER = createActionConst(USERS_NAMESPACE, 'ENABLE_USER');
export const UPDATE_USER_PROFILE = createActionConst(USERS_NAMESPACE, 'UPDATE_USER_PROFILE');

export const UPDATE_USER_EMAIL = createActionConst(USERS_NAMESPACE, 'UPDATE_USER_EMAIL');

export const SIGNUP_USER = createActionConst(USERS_NAMESPACE, 'SIGNUP_USER');

export const STORE_FETCHED_ACTIVE_USERS = createActionConst(USERS_NAMESPACE, 'STORE_FETCHED_ACTIVE_USERS');
export const CLEAR_FETCHED_ACTIVE_USERS = createActionConst(USERS_NAMESPACE, 'CLEAR_FETCHED_ACTIVE_USERS');

export const STORE_FETCHED_DELETED_USERS = createActionConst(USERS_NAMESPACE, 'STORE_FETCHED_DELETED_USERS');
export const CLEAR_FETCHED_DELETED_USERS = createActionConst(USERS_NAMESPACE, 'CLEAR_FETCHED_DELETED_USERS');

export const STORE_USER = createActionConst(USERS_NAMESPACE, 'STORE_USER');
export const CLEAR_USER = createActionConst(USERS_NAMESPACE, 'CLEAR_USER');

export const STORE_IS_FETCHED = createActionConst(USERS_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(USERS_NAMESPACE, 'CLEAR_IS_FETCHED');

export const SAVE_USER_SOCKET = 'saveUser';
export const DELETE_USER_SOCKET = 'deleteUser';
export const SYNC_USER_WITH_SLACK = createActionConst(USERS_NAMESPACE, 'SYNC_USER_WITH_SLACK');

export const CREATE_USER_SUCCESS = createActionConst(USERS_NAMESPACE, 'CREATE_USER_SUCCESS');
export const CLEAR_CREATE_USER_SUCCESS = createActionConst(USERS_NAMESPACE, 'CLEAR_CREATE_USER_SUCCESS');
export const ADD_USER_TO_TENANT_SUCCESS = createActionConst(USERS_NAMESPACE, 'ADD_USER_TO_TENANT_SUCCESS');
export const CLEAR_ADD_USER_TO_TENANT_SUCCESS = createActionConst(USERS_NAMESPACE, 'CLEAR_ADD_USER_TO_TENANT_SUCCESS');

export const STORE_USER_EXISTENCE_CHECK = createActionConst(USERS_NAMESPACE, 'STORE_USER_EXISTENCE_CHECK');
export const CLEAR_USER_EXISTENCE_CHECK = createActionConst(USERS_NAMESPACE, 'CLEAR_USER_EXISTENCE_CHECK');
